import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import {
  FaRegClock,
  FaStickyNote,
  FaPhoneAlt,
  FaFileAlt,
  FaEnvelope,
} from "react-icons/fa";

import ActivitiesTab from "./company-tabs/ActivitiesTab";
import NotesTab from "./company-tabs/NotesTab";
import CallsTab from "./company-tabs/CallsTab";
import FilesTab from "./company-tabs/FilesTab";
import EmailTab from "./company-tabs/EmailTab";

export default function CompanyTabs() {
  const [key, setKey] = useState("notes");

  return (
    <>
      {/* 🔥 INTERNAL CSS */}
<style>{`
  /* OUTER WRAPPER (GREY BACKGROUND LIKE IMAGE) */
  .tabs-wrapper {
    background: #f5f7fa;     /* light grey */
    padding: 12px 12px 0 12px;
    border-radius: 5px;
    margin-top: 10px;        /* 🔥 GAP from header (important) */
  }

  /* INNER WHITE TAB BOX */
  .custom-tabs {
    background: #ffffff;
    border-radius: 9px;
    padding: 6px 10px 0 10px;
  }

  /* REMOVE DEFAULT BORDER */
  .custom-tabs .nav-tabs {
    border-bottom: none !important;
  }

  /* TAB BUTTON */
  .custom-tabs .nav-link {
    border: none !important;
    background: transparent !important;
    color: #6b7280;          /* soft grey text */
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 16px;
    position: relative;
  }

  /* ICON */
  .tab-icon {
    font-size: 14px;
  }

  // /* ACTIVE TAB */
  // .custom-tabs .nav-link.active {
  //   color: #ff6a00 !important;
  //   font-weight: 600;
  // }

  // .custom-tabs .nav-link.active::after {
  //   content: "";
  //   position: absolute;
  //   bottom: -4px;          /* 🔥 matches 2nd image spacing */
  //   left: 10%;
  //   width: 80%;            /* not full width → like design */
  //   height: 2px;
  //   background: #ff6a00;
  //   border-radius: 2px;
  // }

  /* HOVER */
  // .custom-tabs .nav-link:hover {
  //   color: #ff6a00;
  // }

  /* CONTENT GAP */
  .tab-content {
    margin-top: 10px;      /* 🔥 space below tabs */
  }

  /* MOBILE */
  @media (max-width: 768px) {
    .custom-tabs .nav-link {
      padding: 8px 10px;
      font-size: 12px;
    }

    .tab-icon {
      font-size: 12px;
    }
  }
`}</style>

      <div className="tabs-wrapper">
        <Tabs
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="custom-tabs"
          justify
        >
          <Tab
            eventKey="activities"
            title={
              <>
                <FaRegClock className="tab-icon" />
                Activities
              </>
            }
          >
            <ActivitiesTab />
          </Tab>

          <Tab
            eventKey="notes"
            title={
              <>
                <FaStickyNote className="tab-icon" />
                Notes
              </>
            }
          >
            <NotesTab />
          </Tab>

          <Tab
            eventKey="calls"
            title={
              <>
                <FaPhoneAlt className="tab-icon" />
                Calls
              </>
            }
          >
            <CallsTab />
          </Tab>

          <Tab
            eventKey="files"
            title={
              <>
                <FaFileAlt className="tab-icon" />
                Files
              </>
            }
          >
            <FilesTab />
          </Tab>

          <Tab
            eventKey="email"
            title={
              <>
                <FaEnvelope className="tab-icon" />
                Email
              </>
            }
          >
            <EmailTab />
          </Tab>
        </Tabs>
      </div>
    </>
  );
}